/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const GermanFlag = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="4" y="6" width="16" height="4" fill="#353535" />
        <rect x="4" y="10" width="16" height="4" fill="#E2303A" />
        <rect x="4" y="14" width="16" height="4" fill="#F9DA15" />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="2" width="16" height="4" fill="#353535" />
      <rect y="6" width="16" height="4" fill="#E2303A" />
      <rect y="10" width="16" height="4" fill="#F9DA15" />
    </svg>
  );
};

export default GermanFlag;
